import {APP_ROUTES} from "@/app/[locale]/common/constants/app";

export const MAIN_PAGE_TEXT = {
    ABOUT_US: ['We specialize in providing advanced fuel monitoring solutions and professional installation services.',
    'With a focus on accuracy and reliability, we deliver customized solutions that enhance fuel management, reduce costs, and improve operational efficiency.',],
};

export const MAIN_PAGE_TEXT_PH = {
    ABOUT_US: [
        'Dalubhasa kami sa pagbibigay ng advanced na solusyon sa pagsubaybay ng gasolina at propesyonal na serbisyo sa pag-install.',
        'Sa pagtutok sa katumpakan at pagiging maaasahan, naghahatid kami ng mga nakaangkop na solusyon upang mapabuti ang pamamahala ng gasolina, mabawasan ang gastos, at mapataas ang kahusayan ng operasyon.',
    ],
};

export const MAIN_PAGE_LABELS = {
    DIFFERENCES: 'What Makes Us Different?',
    INDUSTRIES: 'Industries We Serve',
    CONTACT_US: 'Contact Us',
};

export const MAIN_PAGE_LABELS_PH = {
    DIFFERENCES: 'Ano ang Nagpapabago sa Amin?',
    INDUSTRIES: 'Mga Industriya',
    CONTACT_US: 'Makipag-ugnayan sa Amin',
};

export const BLOCK_ABOUT_US_EXPERTISE_LIST = ['fuel level sensors', 'flow meters', 'GPS system',
'helping businesses optimize fuel usage', 'track vehicle performance efficiently',];

export const BLOCK_ABOUT_US_EXPERTISE_LIST_PH = [
    'mga sensor ng antas ng gasolina',
    'mga flow meter',
    'GPS system',
    'tumutulong sa mga negosyo na i-optimize ang paggamit ng gasolina',
    'nagsusubaybay ng pagganap ng sasakyan nang mahusay',
];

export const BLOCK_ABOUT_US_LABELS_EN = {
    MAIN_LABEL: 'About Us',
    CONTENT_CARD: 'Our expertise includes installing',
};

export const BLOCK_ABOUT_US_LABELS_PH = {
    MAIN_LABEL: 'Tungkol Sa Amin',
    CONTENT_CARD: 'Ang aming kadalubhasaan ay kinabibilangan ng pag-install',
};

export const FIRST_NEWS = 1;
export const FOURTH_NEWS = 4;

export const BLOCK_DIFFERENCES_CONTENT_LIST = [
    {
        title: '7+ years experience',
        text: 'For more than 7 years in the industry, we’ve been providing smarter fuel governance —from consultation and inspection to installation—ensuring accuracy, control, and efficiency.',
    },
    {
        title: 'Service support',
        text: 'We offer certified installation, service, and after-sales support, including comprehensive warranty services to ensure your fuel monitoring systems performance every step of the way.',
    },
    {
        title: 'Quality and reliability',
        text: 'Our proven expertise and unwavering commitment to excellence enable us to provide quality, efficient, and professional solutions that can make us your trusted partner in fuel governance.',
    },
];

export const BLOCK_DIFFERENCES_CONTENT_LIST_PH = [
    {
        title: '7+ taon ng karanasan',
        text: 'Sa mahigit 7 taon ng karanasan sa industriya, nagbibigay kami ng mga end-to-end na solusyon na iniakma sa iyong pangangailangan—mula sa paunang konsultasyon at inspeksyon hanggang sa pag-install.',
    },
    {
        title: 'Suporta sa Serbisyo',
        text: 'Bilang isang opisyal na dealer ng mga kagamitan ng Technoton, nag-aalok kami ng sertipikadong pag-install, serbisyo, at after-sales support, kabilang ang komprehensibong mga serbisyo ng warranty.',
    },
    {
        title: 'Kalidad at pagiging maaasahan',
        text: 'Ang aming kadalubhasaan at pagtutok sa kalidad ay nagtitiyak ng maaasahan, mahusay, at propesyonal na mga serbisyo na nagtatangi sa amin sa mga solusyon sa pagsubaybay ng gasolina.',
    },
];

export const NEWS_MAX_TEXT_LENGTH = 205;
export const NEWS_MIN_TEXT_LENGTH = 88;
export const NEWS_BREAKPOINT_FOR_TEXT_LENGTH = 600;

export const CONTACT_INFO = {
    PHONE: '+63 998 550 9738',
    EMAIL: 'edjr23deloria@gmail.com',
    ADDRESS: 'Level 1 Plazamart Mall C/O, Herbalshop Araneta Street, Bacolod City 6100, Philippines',
    GOOGLE_MAP_LINK: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d931.7122459073504!2d122.94438209552591!3d10.6687999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x33aecf16f9ae058f%3A0xb49966d857ce9d4b!2sPlaza%20Mart%20Bacolod!5e1!3m2!1sen!2spl!4v1743109716778!5m2!1sen!2spl',
};

export const ABOUT_US_LIST = [
    {
        title: 'Projects',
        href: APP_ROUTES.PROJECTS,
    },
    {
        title: 'Contacts',
        href: APP_ROUTES.CONTACTS,
    },
    {
        title: 'News',
        href: APP_ROUTES.NEWS,
    },
];

export const ABOUT_US_LIST_PH = [
    {
        title: 'Mga Proyekto',
        href: APP_ROUTES.PROJECTS,
    },
    {
        title: 'Mga Kontak',
        href: APP_ROUTES.CONTACTS,
    },
    {
        title: 'Balita',
        href: APP_ROUTES.NEWS,
    },
];
